module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","cancel":"Cancel","confirm":"Confirm"},"fr":{"name":"Nom","cancel":"Annuler","confirm":"Confirmer"},"de":{"name":"Name","cancel":"Stornieren","confirm":"Bestätigen"}}')
  delete Component.options._Ctor
}
